import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { USER_PREFERENCES_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  GetDataCollectionResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (value: Error) => void
  onSuccess?: (value: GetDataCollectionResponse) => void
  children?: () => ReactElement
}

const GetDataCollectionRequest = ({
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${USER_PREFERENCES_SERVICE}/data_collection`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetDataCollectionRequest
